import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Region } from '../models/Region';

@Injectable()
export class RegionService {
  constructor(private http: Http) {}

  all(): Observable<any> {
    const url = environment.api.baseUrl + environment.api.region.all;
    return this.http.get(url).map(res => {
      return res.json().map(j => new Region(j));
    });
  }

  get(regionId: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.region.get.replace('{regionId}', regionId.toString());
    return this.http.get(url).map(res => {
      return new Region(res.json());
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/region.service.ts